import auditNoteByFile from "./auditNoteByFile";
import auditByFile from "./auditByFile";
import finding from "./finding";
import masterDataByFile from "./masterDataByFile";
import entityByFile from "./entityByFile";
import transactionsByFile from "./transactionsByFile";
import findingRuleByFile from "./findingRuleByFile";
import genericOverview from "./genericOverview";
import auditSummaryByFile from "./auditSummaryByFile";
import findingsSchemaWithoutFiscalYear from "./findingsSchemaWithoutFiscalYear";
import genericReportsByFile from "./genericReportsByFile";
import customReportConfiguration from "./customReportConfiguration";
import customReport from "./customReport";
import repository from "./repository";
import submissionSaft from "./submissionSaft";
import newGeneration from "./newGeneration";
import importProfiles from "./importProfiles";
import translationTableUpdateLogs from "./translationTableUpdateLogs";
import {
    BarChart,
    CloudSync,
    Dashboard,
    ShowChart,
    Task,
    StackedLineChart,
    SettingsSuggest,
    Topic,
} from "mosaic-react-icons";
import rawData from "./rawData";
import customCsvRawData from "./customCsvRawData";
let navigation = [];

const menuRouting = {
    translation_tables: [
        {
            level: 0,
            priority: 3,
            name: "label(TranslationTableUpdateLogs)",
            to: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/:modulePrefix/translation_table_update_logs",
            exact: true,
            icon: Dashboard,
            routing: [
                translationTableUpdateLogs(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/:modulePrefix?/translation_table_update_logs",
                    navigation,
                    true,
                    "label(TranslationTableUpdateLogs)",
                ),
            ],
            queries: [],
        },
    ],
    saft_dk: [
        {
            level: 0,
            priority: 1,
            name: "label(Overview)",
            to: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/saft_dk",
            exact: true,
            icon: Dashboard,
            routing: [
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/:modulePrefix(saft_dk)?/",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                ),
            ],
            queries: [],
        },
        {
            level: 0,
            priority: 3,
            name: "label(Audit)",
            icon: Task,
            isToBuildMenu: true,
            navigation: "prop(saftDkGenericMenuAudit)",
            routing: [
                auditByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:entity(nc_audit|nc_audit_schema)?",
                    navigation,
                    true,
                    "label(Audit)",
                    true,
                ),
                auditSummaryByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit_execution_summary",
                    navigation,
                    true,
                    "label(Execution Summary)",
                ),
                auditNoteByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit_notes",
                    navigation,
                    true,
                    "label(Audit Notes)",
                    true,
                ),
                findingRuleByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit/:modulePrefix(saft_dk)?/rules/:id",
                    navigation,
                    true,
                    "label(Rules)",
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_audit",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        genericPrefix: "saft_dk",
                        importId: "",
                    },
                    body: "entity, count, navigation, removeModule",
                },
            ],
        },
        {
            name: "label(Reports)",
            icon: BarChart,
            priority: 4,
            level: 0,
            isToBuildMenu: true,
            navigation: "prop(saftDkGenericMenuReports)",
            routing: [
                genericReportsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_dk)/reports/:entity?",
                    navigation,
                    true,
                    "label(param(entity))",
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_reports",
                    subEntity: "reports",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_dk",
                    },
                    body: "entity, count, navigation",
                },
            ],
        },
        {
            name: "label(SAF-T DK)",
            icon: StackedLineChart,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: [
                {
                    level: 1,
                    name: "label(Master Data)",
                    icon: "master-data",
                    navigation: "prop(saftDkGenericMenuMasterData)",
                },
                {
                    level: 1,
                    name: "label(TransactionsMenu)",
                    icon: "transactions",
                    navigation: "prop(saftDkGenericMenuTransactionalData)",
                },
            ],
            routing: [
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_dk)/master_data/:entity?",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_dk)/master_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_dk)/:entity",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_dk)/:entities*",
                    navigation,
                    true,
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_master_data",
                    subEntity: "master_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_dk",
                    },
                    body: "entity, count",
                },
                {
                    resource: "generic_menu_transactional_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_dk",
                    },
                    body: "entity, count",
                },
            ],
        },
    ],
    csv_dk: [
        {
            level: 0,
            priority: 2,
            name: "label(Source Data Overview)",
            to: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/csv_dk",
            exact: true,
            icon: Dashboard,
            routing: [
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/:modulePrefix(csv_dk)?/",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                ),
            ],
            queries: [],
        },
        {
            name: "label(Source Data)",
            icon: StackedLineChart,
            priority: 6,
            level: 0,
            isToBuildMenu: true,
            navigation: [
                {
                    level: 1,
                    name: "label(Master Data)",
                    icon: "master-data",
                    navigation: "prop(csvDkGenericMenuMasterData)",
                },
                {
                    level: 1,
                    name: "label(TransactionsMenu)",
                    icon: "transactions",
                    navigation: "prop(csvDkGenericMenuTransactionalData)",
                },
            ],
            routing: [
                findingRuleByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit/:modulePrefix(csv_dk)?/rules/:id",
                    navigation,
                    true,
                    "label(Rules)",
                    true,
                ),
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_dk)/master_data/:entity?",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_dk)/master_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_dk)/:entity",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_dk)/:entities*",
                    navigation,
                    true,
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_master_data",
                    subEntity: "master_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "csv_dk",
                    },
                    body: "entity, count",
                },
                {
                    resource: "generic_menu_transactional_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "csv_dk",
                    },
                    body: "entity, count",
                },
            ],
        },
    ],
    saft_lt: [
        {
            level: 0,
            priority: 1,
            name: "label(Overview)",
            to: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/saft_lt",
            exact: true,
            icon: Dashboard,
            routing: [
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/:modulePrefix(saft_lt)?/",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                ),
            ],
            queries: [],
        },
        {
            level: 0,
            priority: 2,
            name: "label(Audit)",
            icon: Task,
            isToBuildMenu: true,
            navigation: "prop(saftLtGenericMenuAudit)",
            routing: [
                auditByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:entity(nc_audit|nc_audit_schema)?",
                    navigation,
                    true,
                    "label(Audit)",
                    true,
                ),
                auditSummaryByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit_execution_summary",
                    navigation,
                    true,
                    "label(Execution Summary)",
                ),
                auditNoteByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit_notes",
                    navigation,
                    true,
                    "label(Audit Notes)",
                    true,
                ),
                findingRuleByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit/:modulePrefix(saft_lt)?/rules/:id",
                    navigation,
                    true,
                    "label(Rules)",
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_audit",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        genericPrefix: "saft_lt",
                        importId: "",
                    },
                    body: "entity, count, navigation, removeModule",
                },
            ],
        },
        {
            name: "label(Reports)",
            icon: BarChart,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: "prop(saftLtGenericMenuReports)",
            routing: [
                genericReportsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_lt)/reports/:entity?",
                    navigation,
                    true,
                    "label(param(entity))",
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_reports",
                    subEntity: "reports",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_lt",
                    },
                    body: "entity, count, navigation",
                },
            ],
        },
        {
            name: "label(SAF-T LT)",
            icon: StackedLineChart,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: [
                {
                    level: 1,
                    name: "label(Master Data)",
                    icon: "master-data",
                    navigation: "prop(saftLtGenericMenuMasterData)",
                },
                {
                    level: 1,
                    name: "label(TransactionsMenu)",
                    icon: "transactions",
                    navigation: "prop(saftLtGenericMenuTransactionalData)",
                },
            ],
            routing: [
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_lt)/master_data/:entity?",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_lt)/master_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_lt)/:entity",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_lt)/:entities*",
                    navigation,
                    true,
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_master_data",
                    subEntity: "master_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_lt",
                    },
                    body: "entity, count",
                },
                {
                    resource: "generic_menu_transactional_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_lt",
                    },
                    body: "entity, count",
                },
            ],
        },
    ],
    csv_lt: [
        {
            level: 0,
            priority: 1,
            name: "label(CSV LT Overview)",
            to: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/csv_lt",
            exact: true,
            icon: Dashboard,
            routing: [
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/:modulePrefix(csv_lt)?/",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                ),
            ],
            queries: [],
        },
        {
            name: "label(CSV LT)",
            icon: StackedLineChart,
            priority: 6,
            level: 0,
            isToBuildMenu: true,
            navigation: [
                {
                    level: 1,
                    name: "label(Master Data)",
                    icon: "master-data",
                    navigation: "prop(csvLtGenericMenuMasterData)",
                },
                {
                    level: 1,
                    name: "label(TransactionsMenu)",
                    icon: "transactions",
                    navigation: "prop(csvLtGenericMenuTransactionalData)",
                },
            ],
            routing: [
                findingRuleByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit/:modulePrefix(csv_lt)?/rules/:id",
                    navigation,
                    true,
                    "label(Rules)",
                    true,
                ),
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_lt)/master_data/:entity?",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_lt)/master_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_lt)/:entity",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_lt)/:entities*",
                    navigation,
                    true,
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_master_data",
                    subEntity: "master_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "csv_lt",
                    },
                    body: "entity, count",
                },
                {
                    resource: "generic_menu_transactional_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "csv_lt",
                    },
                    body: "entity, count",
                },
            ],
        },
    ],
    saft_pl: [
        {
            level: 0,
            priority: 1,
            name: "label(Overview)",
            to: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/saft_pl",
            exact: true,
            icon: Dashboard,
            routing: [
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/:modulePrefix(saft_pl)?/",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                ),
            ],
            queries: [],
        },
        {
            level: 0,
            priority: 2,
            name: "label(Audit)",
            icon: Task,
            navigation: "prop(saftPlGenericMenuAudit)",
            isToBuildMenu: true,
            routing: [
                auditByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:entity(nc_audit|nc_audit_schema)?",
                    navigation,
                    true,
                    "label(Audit)",
                    true,
                ),
                auditSummaryByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit_execution_summary",
                    navigation,
                    true,
                    "label(Execution Summary)",
                ),
                auditNoteByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit_notes",
                    navigation,
                    true,
                    "label(Audit Notes)",
                    true,
                ),
                findingRuleByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit/:modulePrefix(saft_pl)?/rules/:id",
                    navigation,
                    true,
                    "label(Rules)",
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_audit",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        genericPrefix: "saft_pl",
                        importId: "",
                    },
                    body: "entity, count, navigation, removeModule",
                },
            ],
        },
        {
            name: "label(Reports)",
            icon: BarChart,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: "prop(saftPlGenericMenuReports)",
            routing: [
                genericReportsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_pl)/reports/:entity?",
                    navigation,
                    true,
                    "label(param(entity))",
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_reports",
                    subEntity: "reports",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_pl",
                    },
                    body: "entity, count, navigation",
                },
            ],
        },
        {
            name: "label(JPK)",
            icon: StackedLineChart,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: [
                {
                    level: 1,
                    name: "label(Master Data)",
                    icon: "master-data",
                    navigation: "prop(saftPlGenericMenuMasterData)",
                },
                {
                    level: 1,
                    name: "label(TransactionsMenu)",
                    icon: "transactions",
                    navigation: "prop(saftPlGenericMenuTransactionalData)",
                },
            ],
            routing: [
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_pl)/master_data/:entity?",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_pl)/master_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_pl)/:entity",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_pl)/:entities*",
                    navigation,
                    true,
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_master_data",
                    subEntity: "master_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_pl",
                    },
                    body: "entity, count",
                },
                {
                    resource: "generic_menu_transactional_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_pl",
                    },
                    body: "entity, count",
                },
            ],
        },
    ],
    csv_pl: [
        {
            level: 0,
            priority: 1,
            name: "label(CSV PL Overview)",
            to: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/csv_pl",
            exact: true,
            icon: Dashboard,
            routing: [
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/:modulePrefix(csv_pl)?/",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                ),
            ],
            queries: [],
        },
        {
            name: "label(CSV PL)",
            icon: StackedLineChart,
            priority: 6,
            level: 0,
            isToBuildMenu: true,
            navigation: [
                {
                    level: 1,
                    name: "label(Master Data)",
                    icon: "master-data",
                    navigation: "prop(csvPlGenericMenuMasterData)",
                },
                {
                    level: 1,
                    name: "label(TransactionsMenu)",
                    icon: "transactions",
                    navigation: "prop(csvPlGenericMenuTransactionalData)",
                },
            ],
            routing: [
                findingRuleByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit/:modulePrefix(csv_pl)?/rules/:id",
                    navigation,
                    true,
                    "label(Rules)",
                    true,
                ),
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_pl)/master_data/:entity?",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_pl)/master_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_pl)/:entity",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_pl)/:entities*",
                    navigation,
                    true,
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_master_data",
                    subEntity: "master_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "csv_pl",
                    },
                    body: "entity, count",
                },
                {
                    resource: "generic_menu_transactional_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "csv_pl",
                    },
                    body: "entity, count",
                },
            ],
        },
    ],
    saft_fr: [
        {
            level: 0,
            priority: 1,
            name: "label(Overview)",
            to: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/saft_fr",
            exact: true,
            icon: Dashboard,
            routing: [
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/:modulePrefix(saft_fr)?/",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                ),
            ],
            queries: [],
        },
        {
            level: 0,
            priority: 2,
            name: "label(Audit)",
            icon: Task,
            isToBuildMenu: true,
            navigation: "prop(saftFrGenericMenuAudit)",
            routing: [
                auditByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:entity(nc_audit|nc_audit_schema)?",
                    navigation,
                    true,
                    "label(Audit)",
                    true,
                ),
                auditSummaryByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit_execution_summary",
                    navigation,
                    true,
                    "label(Execution Summary)",
                ),
                auditNoteByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit_notes",
                    navigation,
                    true,
                    "label(Audit Notes)",
                    true,
                ),
                findingRuleByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit/:modulePrefix(saft_fr)?/rules/:id",
                    navigation,
                    true,
                    "label(Rules)",
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_audit",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        genericPrefix: "saft_fr",
                        importId: "",
                    },
                    body: "entity, count, navigation, removeModule",
                },
            ],
        },
        {
            name: "label(Reports)",
            icon: BarChart,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: "prop(saftFrGenericMenuReports)",
            routing: [
                genericReportsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_fr)/reports/:entity?",
                    navigation,
                    true,
                    "label(param(entity))",
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_reports",
                    subEntity: "reports",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_fr",
                    },
                    body: "entity, count, navigation",
                },
            ],
        },
        {
            name: "label(SAFT-FR)",
            icon: StackedLineChart,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: [
                {
                    level: 1,
                    name: "label(Master Data)",
                    icon: "master-data",
                    navigation: "prop(saftFrGenericMenuMasterData)",
                },
                {
                    level: 1,
                    name: "label(TransactionsMenu)",
                    icon: "transactions",
                    navigation: "prop(saftFrGenericMenuTransactionalData)",
                },
            ],
            routing: [
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_fr)/master_data/:entity?",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_fr)/master_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_fr)/:entity",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_fr)/:entities*",
                    navigation,
                    true,
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_master_data",
                    subEntity: "master_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_fr",
                    },
                    body: "entity, count",
                },
                {
                    resource: "generic_menu_transactional_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_fr",
                    },
                    body: "entity, count",
                },
            ],
        },
    ],
    csv_fr: [
        {
            level: 0,
            priority: 1,
            name: "label(CSV FR Overview)",
            to: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/csv_fr",
            exact: true,
            icon: Dashboard,
            routing: [
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/:modulePrefix(csv_fr)?/",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                ),
            ],
            queries: [],
        },
        {
            name: "label(CSV Data)",
            icon: StackedLineChart,
            priority: 6,
            level: 0,
            isToBuildMenu: true,
            navigation: [
                {
                    level: 1,
                    name: "label(Master Data)",
                    icon: "master-data",
                    navigation: "prop(csvFrGenericMenuMasterData)",
                },
                {
                    level: 1,
                    name: "label(TransactionsMenu)",
                    icon: "transactions",
                    navigation: "prop(csvFrGenericMenuTransactionalData)",
                },
            ],
            routing: [
                findingRuleByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit/:modulePrefix(csv_fr)?/rules/:id",
                    navigation,
                    true,
                    "label(Rules)",
                    true,
                ),
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_fr)/master_data/:entity?",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_fr)/master_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_fr)/:entity",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_fr)/:entities*",
                    navigation,
                    true,
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_master_data",
                    subEntity: "master_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "csv_fr",
                    },
                    body: "entity, count",
                },
                {
                    resource: "generic_menu_transactional_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "csv_fr",
                    },
                    body: "entity, count",
                },
            ],
        },
    ],
    saft_no: [
        {
            level: 0,
            priority: 1,
            name: "label(Overview)",
            to: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/saft_no",
            exact: true,
            icon: Dashboard,
            routing: [
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/:modulePrefix(saft_no)?/",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                ),
            ],
            queries: [],
        },
        {
            level: 0,
            priority: 2,
            name: "label(Audit)",
            icon: Task,
            isToBuildMenu: true,
            navigation: "prop(saftNoGenericMenuAudit)",
            routing: [
                auditByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:entity(nc_audit|nc_audit_schema)?",
                    navigation,
                    true,
                    "label(Audit)",
                    true,
                ),
                auditSummaryByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit_execution_summary",
                    navigation,
                    true,
                    "label(Execution Summary)",
                ),
                auditNoteByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit_notes",
                    navigation,
                    true,
                    "label(Audit Notes)",
                    true,
                ),
                findingRuleByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit/:modulePrefix(saft_no)?/rules/:id",
                    navigation,
                    true,
                    "label(Rules)",
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_audit",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        genericPrefix: "saft_no",
                        importId: "",
                    },
                    body: "entity, count, navigation, removeModule",
                },
            ],
        },
        {
            name: "label(Reports)",
            icon: BarChart,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: "prop(saftNoGenericMenuReports)",
            routing: [
                genericReportsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_no)/reports/:entity?",
                    navigation,
                    true,
                    "label(param(entity))",
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_reports",
                    subEntity: "reports",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_no",
                    },
                    body: "entity, count, navigation",
                },
            ],
        },
        {
            name: "label(SAFT-NO)",
            icon: StackedLineChart,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: [
                {
                    level: 1,
                    name: "label(Master Data)",
                    icon: "master-data",
                    navigation: "prop(saftNoGenericMenuMasterData)",
                },
                {
                    level: 1,
                    name: "label(TransactionsMenu)",
                    icon: "transactions",
                    navigation: "prop(saftNoGenericMenuTransactionalData)",
                },
            ],
            routing: [
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_no)/master_data/:entity?",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_no)/master_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_no)/:entity",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_no)/:entities*",
                    navigation,
                    true,
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_master_data",
                    subEntity: "master_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_no",
                    },
                    body: "entity, count",
                },
                {
                    resource: "generic_menu_transactional_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_no",
                    },
                    body: "entity, count",
                },
            ],
        },
    ],
    csv_no: [
        {
            level: 0,
            priority: 1,
            name: "label(CSV NO Overview)",
            to: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/csv_no",
            exact: true,
            icon: Dashboard,
            routing: [
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/:modulePrefix(csv_no)?/",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                ),
            ],
            queries: [],
        },
        {
            name: "label(CSV Data)",
            icon: StackedLineChart,
            priority: 6,
            level: 0,
            isToBuildMenu: true,
            navigation: [
                {
                    level: 1,
                    name: "label(Master Data)",
                    icon: "master-data",
                    navigation: "prop(csvNoGenericMenuMasterData)",
                },
                {
                    level: 1,
                    name: "label(TransactionsMenu)",
                    icon: "transactions",
                    navigation: "prop(csvNoGenericMenuTransactionalData)",
                },
            ],
            routing: [
                findingRuleByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit/:modulePrefix(csv_no)?/rules/:id",
                    navigation,
                    true,
                    "label(Rules)",
                    true,
                ),
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_no)/master_data/:entity?",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_no)/master_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_no)/:entity",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_no)/:entities*",
                    navigation,
                    true,
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_master_data",
                    subEntity: "master_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "csv_no",
                    },
                    body: "entity, count",
                },
                {
                    resource: "generic_menu_transactional_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "csv_no",
                    },
                    body: "entity, count",
                },
            ],
        },
    ],
    saft_ro: [
        {
            level: 0,
            priority: 1,
            name: "label(Overview)",
            to: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/saft_ro",
            exact: true,
            icon: Dashboard,
            routing: [
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/:modulePrefix(saft_ro)?/",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                ),
            ],
            queries: [],
        },
        {
            level: 0,
            priority: 2,
            name: "label(Audit)",
            icon: Task,
            isToBuildMenu: true,
            navigation: "prop(saftRoGenericMenuAudit)",
            routing: [
                auditByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:entity(nc_audit|nc_audit_schema)?",
                    navigation,
                    true,
                    "label(Audit)",
                    true,
                ),
                auditSummaryByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit_execution_summary",
                    navigation,
                    true,
                    "label(Execution Summary)",
                ),
                auditNoteByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit_notes",
                    navigation,
                    true,
                    "label(Audit Notes)",
                    true,
                ),
                findingRuleByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit/:modulePrefix(saft_ro)?/rules/:id",
                    navigation,
                    true,
                    "label(Rules)",
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_audit",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        genericPrefix: "saft_ro",
                        importId: "",
                    },
                    body: "entity, count, navigation, removeModule",
                },
            ],
        },
        {
            name: "label(Reports)",
            icon: BarChart,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: "prop(saftRoGenericMenuReports)",
            routing: [
                genericReportsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_ro)/reports/:entity?",
                    navigation,
                    true,
                    "label(param(entity))",
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_reports",
                    subEntity: "reports",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_ro",
                    },
                    body: "entity, count, navigation",
                },
            ],
        },
        {
            name: "label(SAFT-RO)",
            icon: StackedLineChart,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: [
                {
                    level: 1,
                    name: "label(Master Data)",
                    icon: "master-data",
                    navigation: "prop(saftRoGenericMenuMasterData)",
                },
                {
                    level: 1,
                    name: "label(TransactionsMenu)",
                    icon: "transactions",
                    navigation: "prop(saftRoGenericMenuTransactionalData)",
                },
            ],
            routing: [
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_ro)/master_data/:entity?",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_ro)/master_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_ro)/:entity",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_ro)/:entities*",
                    navigation,
                    true,
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_master_data",
                    subEntity: "master_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_ro",
                    },
                    body: "entity, count",
                },
                {
                    resource: "generic_menu_transactional_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_ro",
                    },
                    body: "entity, count",
                },
            ],
        },
    ],
    csv_ro: [
        {
            level: 0,
            priority: 1,
            name: "label(CSV RO Overview)",
            to: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/csv_ro",
            exact: true,
            icon: Dashboard,
            routing: [
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/:modulePrefix(csv_ro)?/",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                ),
            ],
            queries: [],
        },
        {
            name: "label(CSV Data)",
            icon: StackedLineChart,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: [
                {
                    level: 1,
                    name: "label(Master Data)",
                    icon: "master-data",
                    navigation: "prop(csvRoGenericMenuMasterData)",
                },
                {
                    level: 1,
                    name: "label(TransactionsMenu)",
                    icon: "transactions",
                    navigation: "prop(csvRoGenericMenuTransactionalData)",
                },
            ],
            routing: [
                findingRuleByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit/:modulePrefix(csv_ro)?/rules/:id",
                    navigation,
                    true,
                    "label(Rules)",
                    true,
                ),
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_ro)/master_data/:entity?",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_ro)/master_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_ro)/:entity",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_ro)/:entities*",
                    navigation,
                    true,
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_master_data",
                    subEntity: "master_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "csv_ro",
                    },
                    body: "entity, count",
                },
                {
                    resource: "generic_menu_transactional_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "csv_ro",
                    },
                    body: "entity, count",
                },
            ],
        },
    ],
    saft_mx: [
        {
            level: 0,
            priority: 1,
            name: "label(Overview)",
            to: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/saft_mx",
            exact: true,
            icon: Dashboard,
            routing: [
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/:modulePrefix(saft_mx)?/",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                ),
            ],
            queries: [],
        },
        {
            level: 0,
            priority: 2,
            name: "label(Audit)",
            icon: Task,
            isToBuildMenu: true,
            navigation: "prop(saftMxGenericMenuAudit)",
            routing: [
                auditByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:entity(nc_audit|nc_audit_schema)?",
                    navigation,
                    true,
                    "label(Audit)",
                    true,
                ),
                auditSummaryByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit_execution_summary",
                    navigation,
                    true,
                    "label(Execution Summary)",
                ),
                auditNoteByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit_notes",
                    navigation,
                    true,
                    "label(Audit Notes)",
                    true,
                ),
                findingRuleByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit/:modulePrefix(saft_mx)?/rules/:id",
                    navigation,
                    true,
                    "label(Rules)",
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_audit",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        genericPrefix: "saft_mx",
                        importId: "",
                    },
                    body: "entity, count, navigation, removeModule",
                },
            ],
        },
        {
            name: "label(Reports)",
            icon: BarChart,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: "prop(saftMxGenericMenuReports)",
            routing: [
                genericReportsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_mx)/reports/:entity?",
                    navigation,
                    true,
                    "label(param(entity))",
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_reports",
                    subEntity: "reports",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_mx",
                    },
                    body: "entity, count, navigation",
                },
            ],
        },
        {
            name: "label(E-Accounting)",
            icon: StackedLineChart,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: [
                {
                    level: 1,
                    name: "label(Master Data)",
                    icon: "master-data",
                    navigation: "prop(saftMxGenericMenuMasterData)",
                },
                {
                    level: 1,
                    name: "label(TransactionsMenu)",
                    icon: "transactions",
                    navigation: "prop(saftMxGenericMenuTransactionalData)",
                },
            ],
            routing: [
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_mx)/master_data/:entity?",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_mx)/master_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_mx)/:entity",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_mx)/:entities*",
                    navigation,
                    true,
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_master_data",
                    subEntity: "master_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_mx",
                    },
                    body: "entity, count",
                },
                {
                    resource: "generic_menu_transactional_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_mx",
                    },
                    body: "entity, count",
                },
            ],
        },
    ],
    saft_bg: [
        {
            level: 0,
            priority: 1,
            name: "label(Overview)",
            to: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/saft_bg",
            exact: true,
            icon: Dashboard,
            routing: [
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/:modulePrefix(saft_bg)?/",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                ),
            ],
            queries: [],
        },
        {
            level: 0,
            priority: 2,
            name: "label(Audit)",
            icon: Task,
            isToBuildMenu: true,
            navigation: "prop(saftBgGenericMenuAudit)",
            routing: [
                auditByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:entity(nc_audit|nc_audit_schema)?",
                    navigation,
                    true,
                    "label(Audit)",
                    true,
                ),
                auditSummaryByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit_execution_summary",
                    navigation,
                    true,
                    "label(Execution Summary)",
                ),
                auditNoteByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit_notes",
                    navigation,
                    true,
                    "label(Audit Notes)",
                    true,
                ),
                findingRuleByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit/:modulePrefix(saft_bg)?/rules/:id",
                    navigation,
                    true,
                    "label(Rules)",
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_audit",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        genericPrefix: "saft_bg",
                        importId: "",
                    },
                    body: "entity, count, navigation, removeModule",
                },
            ],
        },
        {
            name: "label(Reports)",
            icon: BarChart,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: "prop(saftRoGenericMenuReports)",
            routing: [
                genericReportsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_bg)/reports/:entity?",
                    navigation,
                    true,
                    "label(param(entity))",
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_reports",
                    subEntity: "reports",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_bg",
                    },
                    body: "entity, count, navigation",
                },
            ],
        },
        {
            name: "label(SAFT-BG)",
            icon: StackedLineChart,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: [
                {
                    level: 1,
                    name: "label(Master Data)",
                    icon: "master-data",
                    navigation: "prop(saftBgGenericMenuMasterData)",
                },
                {
                    level: 1,
                    name: "label(TransactionsMenu)",
                    icon: "transactions",
                    navigation: "prop(saftBgGenericMenuTransactionalData)",
                },
            ],
            routing: [
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_bg)/master_data/:entity?",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_bg)/master_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_bg)/:entity",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_bg)/:entities*",
                    navigation,
                    true,
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_master_data",
                    subEntity: "master_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_bg",
                    },
                    body: "entity, count",
                },
                {
                    resource: "generic_menu_transactional_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_bg",
                    },
                    body: "entity, count",
                },
            ],
        },
    ],
    csv_bg: [
        {
            level: 0,
            priority: 1,
            name: "label(CSV BG Overview)",
            to: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/csv_bg",
            exact: true,
            icon: Dashboard,
            routing: [
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/:modulePrefix(csv_bg)?/",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                ),
            ],
            queries: [],
        },
        {
            name: "label(CSV Data)",
            icon: StackedLineChart,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: [
                {
                    level: 1,
                    name: "label(Master Data)",
                    icon: "master-data",
                    navigation: "prop(csvBgGenericMenuMasterData)",
                },
                {
                    level: 1,
                    name: "label(TransactionsMenu)",
                    icon: "transactions",
                    navigation: "prop(csvBgGenericMenuTransactionalData)",
                },
            ],
            routing: [
                findingRuleByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit/:modulePrefix(csv_bg)?/rules/:id",
                    navigation,
                    true,
                    "label(Rules)",
                    true,
                ),
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_bg)/master_data/:entity?",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_bg)/master_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_bg)/:entity",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_bg)/:entities*",
                    navigation,
                    true,
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_master_data",
                    subEntity: "master_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "csv_bg",
                    },
                    body: "entity, count",
                },
                {
                    resource: "generic_menu_transactional_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "csv_bg",
                    },
                    body: "entity, count",
                },
            ],
        },
    ],
    erp_pt: [
        {
            level: 0,
            priority: 1,
            name: "label(Overview)",
            to: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/erp_pt",
            exact: true,
            icon: Dashboard,
            routing: [
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/:modulePrefix(erp_pt)?/",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                ),
            ],
            queries: [],
        },
        {
            level: 0,
            priority: 2,
            name: "label(Audit)",
            icon: Task,
            isToBuildMenu: true,
            navigation: "prop(erpPtGenericMenuAudit)",
            routing: [
                auditByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:entity(nc_audit|nc_audit_schema)?",
                    navigation,
                    true,
                    "label(Audit)",
                    true,
                ),
                auditSummaryByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit_execution_summary",
                    navigation,
                    true,
                    "label(Execution Summary)",
                ),
                auditNoteByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit_notes",
                    navigation,
                    true,
                    "label(Audit Notes)",
                    true,
                ),
                findingRuleByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit/:modulePrefix(erp_pt)?/rules/:id",
                    navigation,
                    true,
                    "label(Rules)",
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_audit",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        genericPrefix: "erp_pt",
                        importId: "",
                    },
                    body: "entity, count, navigation, removeModule",
                },
            ],
        },
        {
            name: "label(ERP PT)",
            icon: StackedLineChart,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: [
                {
                    level: 1,
                    name: "label(Master Data)",
                    icon: "master-data",
                    navigation: "prop(erpPtGenericMenuMasterData)",
                },
                {
                    level: 1,
                    name: "label(TransactionsMenu)",
                    icon: "transactions",
                    navigation: "prop(erpPtGenericMenuTransactionalData)",
                },
            ],
            routing: [
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(erp_pt)/master_data/:entity?",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(erp_pt)/master_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(erp_pt)/:entity",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(erp_pt)/:entities*",
                    navigation,
                    true,
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_master_data",
                    subEntity: "master_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "erp_pt",
                    },
                    body: "entity, count",
                },
                {
                    resource: "generic_menu_transactional_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "erp_pt",
                    },
                    body: "entity, count",
                },
            ],
        },
    ],
    custom_report: [
        {
            level: 0,
            priority: 3,
            name: "label(Custom Reports)",
            //Quick fix to saft_pt (use only in PT), need other approach
            to: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/saft_pt/custom_reports",
            exact: true,
            icon: ShowChart,
            routing: [
                customReport(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix/custom_reports/:id?",
                    navigation,
                    true,
                    "label(Custom Report)",
                ),
            ],
        },
    ],
    saft_pt: [
        {
            level: 0,
            priority: 1,
            name: "label(Overview)",
            to: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/saft_pt",
            exact: true,
            icon: Dashboard,
            routing: [
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/:modulePrefix(saft_pt)?/",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                ),
            ],
            queries: [],
        },
        {
            level: 0,
            priority: 2,
            name: "label(Audit)",
            icon: Task,
            isToBuildMenu: true,
            navigation: "prop(saftPtGenericMenuAudit)",
            routing: [
                auditByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:entity(nc_audit|nc_audit_schema)?",
                    navigation,
                    true,
                    "label(Audit)",
                    true,
                ),
                auditSummaryByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit_execution_summary",
                    navigation,
                    true,
                    "label(Execution Summary)",
                ),
                auditNoteByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit_notes",
                    navigation,
                    true,
                    "label(Audit Notes)",
                    true,
                ),
                findingRuleByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit/:modulePrefix(saft_pt)?/rules/:id",
                    navigation,
                    true,
                    "label(Rules)",
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_audit",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        genericPrefix: "saft_pt",
                        importId: "",
                    },
                    body: "entity, count, navigation, removeModule",
                },
            ],
        },
        {
            name: "label(Reports)",
            icon: BarChart,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: "prop(saftPtGenericMenuReports)",
            routing: [
                genericReportsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_pt)/reports/:entity?",
                    navigation,
                    true,
                    "label(param(entity))",
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_reports",
                    subEntity: "reports",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_pt",
                    },
                    body: "entity, count, navigation",
                },
            ],
        },
        {
            name: "label(SAFT_PT)",
            icon: StackedLineChart,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: [
                {
                    level: 1,
                    name: "label(Master Data)",
                    icon: "master-data",
                    navigation: "prop(saftPtGenericMenuMasterData)",
                },
                {
                    level: 1,
                    name: "label(TransactionsMenu)",
                    icon: "transactions",
                    navigation: "prop(saftPtGenericMenuTransactionalData)",
                },
            ],
            routing: [
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_pt)/master_data/:entity?",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_pt)/master_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_pt)/:entity",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_pt)/:entities*",
                    navigation,
                    true,
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_master_data",
                    subEntity: "master_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_pt",
                    },
                    body: "entity, count",
                },
                {
                    resource: "generic_menu_transactional_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_pt",
                    },
                    body: "entity, count",
                },
            ],
        },
    ],
    raw_data: [
        {
            level: 0,
            priority: 3,
            name: "label(RAW DATA)",
            icon: Topic,
            to: "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix?/raw_data/:entityRawData",
            routing: [
                rawData(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix?/raw_data/:entityRawData?",
                    navigation,
                    true,
                    true,
                ),
            ],
            queries: [],
        },
    ],
    custom_templates: [
        {
            level: 0,
            priority: 3,
            name: "label(Custom Templates Raw Data)",
            icon: Topic,
            to: "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/custom_templates/:entityRawData",
            routing: [
                customCsvRawData(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(custom_templates)/:entityRawData?",
                    navigation,
                    true,
                    true,
                ),
            ],
            queries: [],
        },
    ],
    csv_pt: [
        {
            name: "label(CSV Data)",
            icon: StackedLineChart,
            priority: 6,
            level: 0,
            isToBuildMenu: true,
            navigation: [
                {
                    level: 1,
                    name: "label(Master Data)",
                    icon: "master-data",
                    navigation: "prop(csvPtGenericMenuMasterData)",
                },
                {
                    level: 1,
                    name: "label(TransactionsMenu)",
                    icon: "transactions",
                    navigation: "prop(csvPtGenericMenuTransactionalData)",
                },
            ],
            routing: [
                findingRuleByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit/:modulePrefix(csv_pt)?/rules/:id",
                    navigation,
                    true,
                    "label(Rules)",
                    true,
                ),
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId([0-9]*|full)?/:modulePrefix(csv_pt)/master_data/:entity?",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId([0-9]*|full)?/:modulePrefix(csv_pt)/master_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId([0-9]*|full)?/:modulePrefix(csv_pt)/:entity",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId([0-9]*|full)?/:modulePrefix(csv_pt)/:entities*",
                    navigation,
                    true,
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_master_data",
                    subEntity: "master_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "csv_pt",
                    },
                    body: "entity, count",
                },
                {
                    resource: "generic_menu_transactional_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "csv_pt",
                    },
                    body: "entity, count",
                },
            ],
        },
    ],
    saft_cv: [
        {
            level: 0,
            priority: 1,
            name: "label(Overview)",
            to: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/saft_cv",
            exact: true,
            icon: Dashboard,
            routing: [
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/:modulePrefix(saft_cv)?/",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                ),
            ],
            queries: [],
        },
        {
            level: 0,
            priority: 2,
            name: "label(Audit)",
            icon: Task,
            isToBuildMenu: true,
            navigation: "prop(saftCvGenericMenuAudit)",
            routing: [
                auditByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:entity(nc_audit|nc_audit_schema)?",
                    navigation,
                    true,
                    "label(Audit)",
                    true,
                ),
                auditSummaryByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit_execution_summary",
                    navigation,
                    true,
                    "label(Execution Summary)",
                ),
                auditNoteByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit_notes",
                    navigation,
                    true,
                    "label(Audit Notes)",
                    true,
                ),
                findingRuleByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit/:modulePrefix(saft_cv)?/rules/:id",
                    navigation,
                    true,
                    "label(Rules)",
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_audit",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        genericPrefix: "saft_pt",
                        importId: "",
                    },
                    body: "entity, count, navigation, removeModule",
                },
            ],
        },
        {
            name: "label(Reports)",
            icon: BarChart,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: "prop(saftCvGenericMenuReports)",
            routing: [
                genericReportsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_cv)/reports/:entity?",
                    navigation,
                    true,
                    "label(param(entity))",
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_reports",
                    subEntity: "reports",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_cv",
                    },
                    body: "entity, count, navigation",
                },
            ],
        },
        {
            name: "label(SAFT_CV)",
            icon: StackedLineChart,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: [
                {
                    level: 1,
                    name: "label(Master Data)",
                    icon: "master-data",
                    navigation: "prop(saftCvGenericMenuMasterData)",
                },
                {
                    level: 1,
                    name: "label(TransactionsMenu)",
                    icon: "transactions",
                    navigation: "prop(saftCvGenericMenuTransactionalData)",
                },
            ],
            routing: [
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_cv)/master_data/:entity?",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_cv)/master_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_cv)/:entity",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_cv)/:entities*",
                    navigation,
                    true,
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_master_data",
                    subEntity: "master_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_cv",
                    },
                    body: "entity, count",
                },
                {
                    resource: "generic_menu_transactional_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_cv",
                    },
                    body: "entity, count",
                },
            ],
        },
    ],
    generic_generator: [
        {
            level: 0,
            priority: 101,
            name: "label(File Generation)",
            to: "/:projectId/:fiscalYear/:importId/repository/generation",
            icon: SettingsSuggest,
            isToBuildMenu: true,
            navigation: [],
            routing: [
                newGeneration(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear/:importId/repository/:section(generation)",
                    navigation,
                    true,
                ),
            ],
            queries: [],
        },
    ],
    repository: [
        {
            level: 0,
            priority: 100,
            name: "label(Repository)",
            to: "/:projectId/:fiscalYear/:importId/repository/activity",
            icon: CloudSync,
            isToBuildMenu: true,
            navigation: [],
            routing: [
                repository(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/repository/:urlRedir(redirect)",
                    navigation,
                ),
                newGeneration(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear/:importId/repository/:section(generation)",
                    navigation,
                    true,
                ),
                newGeneration(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/repository/:section(generation)",
                    navigation,
                    false,
                ),
                repository(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear/:importId/repository/:section(merge_collisions)",
                    navigation,
                ),
                submissionSaft(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear/:importId/repository/:section(submission_saft)",
                    navigation,
                ),
                importProfiles(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId([0-9]*|full)/repository/:section(import_profiles)",
                    navigation,
                ),
                repository(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/repository/merge_collisions",
                    navigation,
                ),
                customReportConfiguration(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear/:importId/repository/:section(custom_reports_by_project)",
                    navigation,
                    false,
                    true,
                    true,
                ),
                customReportConfiguration(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/repository/:section(custom_reports_by_project)",
                    navigation,
                    false,
                    true,
                    true,
                ),

                repository(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId([0-9]*|full)/repository/:section(activity)",
                    navigation,
                    true,
                ),

                repository(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId([0-9]*|full)/repository/:section/:id",
                    navigation,
                ),

                repository(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId([0-9]*|full)/repository/:section?",
                    navigation,
                ),

                repository(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/repository/:section?",
                    navigation,
                ),

                findingsSchemaWithoutFiscalYear(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit/:modulePrefix/:section(audit_findings)",
                    navigation,
                    true,
                    "label(Findings)",
                ),

                finding(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit/:modulePrefix/:section(audit_findings)/:id",
                    navigation,
                    true,
                    "label(Finding)",
                ),
            ],
            queries: [],
        },
    ],
    pt_mod_10: [
        {
            name: "label(Modelo 10)",
            icon: StackedLineChart,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: [
                {
                    level: 1,
                    name: "label(Master Data)",
                    icon: "master-data",
                    navigation: "prop(ptMod_10GenericMenuMasterData)",
                },
                {
                    level: 1,
                    name: "label(TransactionsMenu)",
                    icon: "transactions",
                    navigation: "prop(ptMod_10GenericMenuTransactionalData)",
                },
            ],
            routing: [
                findingRuleByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit/:modulePrefix(pt_mod_10)?/rules/:id",
                    navigation,
                    true,
                    "label(Rules)",
                    true,
                ),
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(pt_mod_10)/master_data/:entity?",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(pt_mod_10)/master_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(pt_mod_10)/:entity",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(pt_mod_10)/:entities*",
                    navigation,
                    true,
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_master_data",
                    subEntity: "master_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "pt_mod_10",
                    },
                    body: "entity, count",
                },
                {
                    resource: "generic_menu_transactional_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "pt_mod_10",
                    },
                    body: "entity, count",
                },
            ],
        },
    ],
    pt_dmr: [
        {
            name: "label(DMR)",
            icon: StackedLineChart,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: [
                {
                    level: 1,
                    name: "label(Master Data)",
                    icon: "master-data",
                    navigation: "prop(ptDmrGenericMenuMasterData)",
                },
                {
                    level: 1,
                    name: "label(TransactionsMenu)",
                    icon: "transactions",
                    navigation: "prop(ptDmrGenericMenuTransactionalData)",
                },
            ],
            routing: [
                findingRuleByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit/:modulePrefix(pt_dmr)?/rules/:id",
                    navigation,
                    true,
                    "label(Rules)",
                    true,
                ),
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(pt_dmr)/master_data/:entity?",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(pt_dmr)/master_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(pt_dmr)/:entity",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(pt_dmr)/:entities*",
                    navigation,
                    true,
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_master_data",
                    subEntity: "master_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "pt_dmr",
                    },
                    body: "entity, count",
                },
                {
                    resource: "generic_menu_transactional_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "pt_dmr",
                    },
                    body: "entity, count",
                },
            ],
        },
    ],
    adds: [
        {
            name: "label(additional_datasets)",
            icon: StackedLineChart,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: [
                {
                    level: 1,
                    name: "label(Master Data)",
                    icon: "master-data",
                    navigation: "prop(addsGenericMenuMasterData)",
                },
                {
                    level: 1,
                    name: "label(TransactionsMenu)",
                    icon: "transactions",
                    navigation: "prop(addsGenericMenuTransactionalData)",
                },
            ],
            routing: [
                findingRuleByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit/:modulePrefix(adds)?/rules/:id",
                    navigation,
                    true,
                    "label(Rules)",
                    true,
                ),
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(adds)/master_data/:entity?",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(adds)/master_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(adds)/:entity",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(adds)/:entities*",
                    navigation,
                    true,
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_master_data",
                    subEntity: "master_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "adds",
                    },
                    body: "entity, count",
                },
                {
                    resource: "generic_menu_transactional_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "adds",
                    },
                    body: "entity, count",
                },
            ],
        },
    ],
    saft_ao: [
        {
            level: 0,
            priority: 1,
            name: "label(Overview)",
            to: "/:projectId/:fiscalYear([0-9]{4})/:importId([0-9]*|full)/saft_ao",
            exact: true,
            icon: Dashboard,
            routing: [
                genericOverview(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)?/:importId([0-9]*|full)?/:modulePrefix(saft_ao)?/",
                    navigation,
                    true,
                    "label(Overview)",
                    true,
                ),
            ],
            queries: [],
        },
        {
            level: 0,
            priority: 2,
            name: "label(Audit)",
            icon: Task,
            isToBuildMenu: true,
            navigation: "prop(saftAoGenericMenuAudit)",
            routing: [
                auditByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:entity(nc_audit|nc_audit_schema)?",
                    navigation,
                    true,
                    "label(Audit)",
                    true,
                ),
                auditSummaryByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit_execution_summary",
                    navigation,
                    true,
                    "label(Execution Summary)",
                ),
                auditNoteByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit_notes",
                    navigation,
                    true,
                    "label(Audit Notes)",
                    true,
                ),
                findingRuleByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit/:modulePrefix(saft_ao)?/rules/:id",
                    navigation,
                    true,
                    "label(Rules)",
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_audit",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        genericPrefix: "saft_ao",
                        importId: "",
                    },
                    body: "entity, count, navigation, removeModule",
                },
            ],
        },
        {
            name: "label(Reports)",
            icon: BarChart,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: "prop(saftAoGenericMenuReports)",
            routing: [
                genericReportsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_ao)/reports/:entity?",
                    navigation,
                    true,
                    "label(param(entity))",
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_reports",
                    subEntity: "reports",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_ao",
                    },
                    body: "entity, count, navigation",
                },
            ],
        },
        {
            name: "label(saft_ao)",
            icon: StackedLineChart,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: [
                {
                    level: 1,
                    name: "label(Master Data)",
                    icon: "master-data",
                    navigation: "prop(saftAoGenericMenuMasterData)",
                },
                {
                    level: 1,
                    name: "label(TransactionsMenu)",
                    icon: "transactions",
                    navigation: "prop(saftAoGenericMenuTransactionalData)",
                },
            ],
            routing: [
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_ao)/master_data/:entity?",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_ao)/master_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_ao)/:entity",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(saft_ao)/:entities*",
                    navigation,
                    true,
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_master_data",
                    subEntity: "master_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_ao",
                    },
                    body: "entity, count",
                },
                {
                    resource: "generic_menu_transactional_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "saft_ao",
                    },
                    body: "entity, count",
                },
            ],
        },
    ],
    csv_ao_m2: [
        {
            name: "label(csv_ao_m2)",
            icon: StackedLineChart,
            priority: 5,
            level: 0,
            isToBuildMenu: true,
            navigation: [
                {
                    level: 1,
                    name: "label(Master Data)",
                    icon: "master-data",
                    navigation: "prop(csvAoM2GenericMenuMasterData)",
                },
                {
                    level: 1,
                    name: "label(TransactionsMenu)",
                    icon: "transactions",
                    navigation: "prop(csvAoM2GenericMenuTransactionalData)",
                },
            ],
            routing: [
                findingRuleByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit/:modulePrefix(csv_ao_m2)?/rules/:id",
                    navigation,
                    true,
                    "label(Rules)",
                    true,
                ),
                masterDataByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_ao_m2)/master_data/:entity?",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_ao_m2)/master_data/:entities*",
                    navigation,
                    true,
                    true,
                ),
                transactionsByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_ao_m2)/:entity",
                    navigation,
                    true,
                    true,
                ),
                entityByFile(
                    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix(csv_ao_m2)/:entities*",
                    navigation,
                    true,
                    true,
                ),
            ],
            queries: [
                {
                    resource: "generic_menu_master_data",
                    subEntity: "master_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "csv_ao_m2",
                    },
                    body: "entity, count",
                },
                {
                    resource: "generic_menu_transactional_data",
                    args: {
                        projectId: "",
                        fiscalYear: "",
                        importId: "",
                        genericPrefix: "csv_ao_m2",
                    },
                    body: "entity, count",
                },
            ],
        },
    ],
};

const filteredQueriesByModules = (modules) => {
    if (modules && modules.length > 0) {
        const filteredRoutes = (modules || []).reduce((acc, elem) => {
            const menuArray = menuRouting[`${elem}`];
            const queries = (menuArray || [])
                .filter((elem) => elem.queries !== undefined)
                .map(({ queries }) => {
                    return queries;
                });
            acc.push(...queries);
            return acc;
        }, []);
        return filteredRoutes.flat();
    }
    return [];
};

const filteredQueriesByModulesForMenu = (modules) => {
    if (modules && modules.length > 0) {
        return (modules || []).reduce((acc, elem) => {
            const menuArray = menuRouting[`${elem}`];
            const queries = (menuArray || [])
                .filter((elem) => elem.isToBuildMenu && elem.queries !== undefined)
                .map(({ queries }) => {
                    return queries;
                });

            acc.push({ [`${elem}`]: queries.flat() });
            return acc;
        }, []);
    }
    return [];
};

const filteredNavigationByModules = (modules) => {
    let filteredRoutes = [];
    if (modules && modules.length > 0) {
        const reorderedArray = reorderRouting(modules);
        iterateNavigation(reorderedArray, filteredRoutes);
    }
    return filteredRoutes;
};

const reorderRouting = (modules) => {
    if (modules && modules.length > 0) {
        const filteredRoutes = (modules || []).reduce((acc, elem) => {
            const menuArray = menuRouting[`${elem}`];
            if (menuArray) {
                acc.push(...menuArray);
            }
            return acc;
        }, []);
        return filteredRoutes.sort(function (a, b) {
            return a.priority - b.priority;
        });
    }
    return [];
};

const getFirstModuleOfArray = (modules) => {
    if (modules && modules.length > 0) {
        const firstModule = Object.keys(menuRouting).find(
            (element) => modules.indexOf(element) >= 0,
        );
        return firstModule || "";
    }
    return [];
};

const filteredRoutesByModules = (modules) => {
    let filteredRoutes = [];
    if ((modules || []).length !== 0) {
        const reorderedArray = reorderRouting(modules);
        navigation.splice(0, navigation.length, ...constructMenu(reorderedArray)); //prevent navigation to duplicate entries
        iterateRouting(reorderedArray, filteredRoutes);
    }

    return filteredRoutes.flat();
};

const constructMenu = (reorderedArray) => {
    //const menuToUse = [...structuredClone(reorderedArray)]; //deep copy of array, to prevent any mutation on the original routing

    const navigationContent = reorderedArray.map(({ routing, queries, ...restNavigation }) => {
        return restNavigation;
    });
    return [...navigationContent];
};

const iterateNavigation = (navigation, arrayOfNavigations) => {
    arrayOfNavigations.push(...navigation);
};

const iterateRouting = (navigation, arrayOfNavigations) => {
    const mergeTo = navigation.map(({ routing, queries, ...restNavigation }) => {
        if (restNavigation && Array.isArray(restNavigation)) {
            iterateRouting(restNavigation, arrayOfNavigations);
        }
        return routing || [];
    });
    arrayOfNavigations.push(...(mergeTo.flat() || []));
};

export {
    menuRouting,
    filteredQueriesByModules,
    filteredRoutesByModules,
    filteredNavigationByModules,
    filteredQueriesByModulesForMenu,
    getFirstModuleOfArray,
};
